import { render } from "./RegiaoStatus.vue?vue&type=template&id=6e3e0244&ts=true"
import script from "./RegiaoStatus.vue?vue&type=script&lang=ts"
export * from "./RegiaoStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__